import { createContext } from 'react';
import CommonStore from './commonStore';
import SearchStore from './searchStore';
import AppSettingsStore from './appSettingsStore';

export class RootStore {
    public commonStore: CommonStore;
    public searchStore: SearchStore;
    public appSettingsStore: AppSettingsStore;

    constructor() {
        this.commonStore = new CommonStore(this);
        this.searchStore = new SearchStore(this);
        this.appSettingsStore = new AppSettingsStore(this);
    }
}

export const RootStoreContext = createContext(new RootStore());